import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom';

const Profile = () => {

    const [isEditing, setIsEditing] = useState(false);

    const [formData, setFormData] = useState({
        firstName: "Emma",
        lastName: "Johnson",
        email: "emma_johnson@gmail.com",
        phone: "(123)-456-7890",
        dob: "1995-06-15"
    });

    const [profileImage, setProfileImage] = useState("images/avatars/avatar-3.png");

    const fileInputRef = useRef(null);

    const handleEditToggle = () => {
        if (isEditing) {
            console.log("Saved Data:", formData);
            
        }
        setIsEditing(!isEditing);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const imageURL = URL.createObjectURL(file);
            setProfileImage(imageURL);
        }
    };

    return (
        <div className="page-wrapper">
            <div className="page-content">

                <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                    <div className="breadcrumb-title pe-3">Profile</div>
                    <div className="ps-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item">
                                    <Link to="#"><i className="bx bx-home-alt" /></Link>
                                </li>
                                <li className="breadcrumb-item active">Profile</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <div className="container">
                    <div className="main-body">
                        <div className="row">

                            {/* LEFT SIDE */}
                            <div className="col-lg-4">
                                <div className="card">
                                    <div className="card-body text-center">
                                        <div className="profile-upload-img">

                                            <img
                                                src={profileImage}
                                                alt="Admin"
                                                className="rounded-circle p-1 bg-primary"
                                                width={110}
                                            />

                                            <div className="mt-3">
                                                <h4>{formData.firstName} {formData.lastName}</h4>

                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    hidden
                                                    ref={fileInputRef}
                                                    onChange={handleImageChange}
                                                />

                                                <button
                                                    className="btn btn-primary btn-sm mt-2"
                                                    onClick={handleImageClick}
                                                >
                                                    Change Photo
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT SIDE */}
                            <div className="col-lg-8">
                                <div className="card">
                                    <div className="card-body">

                                        {/* First Name */}
                                        <div className="row mb-3">
                                            <div className="col-sm-3"><h6>First Name</h6></div>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    name="firstName"
                                                    className="form-control"
                                                    value={formData.firstName}
                                                    onChange={handleChange}
                                                    readOnly={!isEditing}
                                                />
                                            </div>
                                        </div>

                                        {/* Last Name */}
                                        <div className="row mb-3">
                                            <div className="col-sm-3"><h6>Last Name</h6></div>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    name="lastName"
                                                    className="form-control"
                                                    value={formData.lastName}
                                                    onChange={handleChange}
                                                    readOnly={!isEditing}
                                                />
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <div className="row mb-3">
                                            <div className="col-sm-3"><h6>Email</h6></div>
                                            <div className="col-sm-9">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    readOnly={!isEditing}
                                                />
                                            </div>
                                        </div>

                                        {/* Phone */}
                                        <div className="row mb-3">
                                            <div className="col-sm-3"><h6>Phone Number</h6></div>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    name="phone"
                                                    className="form-control"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    readOnly={!isEditing}
                                                />
                                            </div>
                                        </div>

                                        {/* DOB */}
                                        <div className="row mb-4">
                                            <div className="col-sm-3"><h6>DOB</h6></div>
                                            <div className="col-sm-9">
                                                <input
                                                    type="date"
                                                    name="dob"
                                                    className="form-control"
                                                    value={formData.dob}
                                                    onChange={handleChange}
                                                    readOnly={!isEditing}
                                                />
                                            </div>
                                        </div>

                                        {/* Edit Button */}
                                        <div className="text-end">
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={handleEditToggle}
                                            >
                                                {isEditing ? "Save Profile" : "Edit Profile"}
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Profile;
